<div class="password-page">
  <!-- Profile Image -->
  <div class="profile-header">
    <div class="image-wrapper">
      <img *ngIf="userImage; else defaultAvatar" [src]="userImage" alt="Profile Picture" />
      <ng-template #defaultAvatar>
        <div class="avatar-placeholder">{{ userService.getUserInitials() }}</div>
      </ng-template>
    </div>
    <div class="user-info">
      <h3>{{ userService.getUserInfo()?.name || ('User Name' | translate) }}</h3>
      <p class="hint">{{ "Change your password below" | translate }}</p>
    </div>
  </div>

  <!-- Password Form -->
  <form [formGroup]="passwordForm" class="form-section mt-3">
    <div class="form-row">
      <label>{{ "Current Password" | translate }}</label>
      <div class="input-wrapper">
        <input [type]="showPassword.current ? 'text' : 'password'" formControlName="currentPassword"
          placeholder="{{ 'Enter current password' | translate }}" />
        <i class="bi" [ngClass]="showPassword.current ? 'bi-eye-slash' : 'bi-eye'"
          (click)="togglePassword('current')"></i>
      </div>
    </div>

    <div class="form-row">
      <label>{{ "New Password" | translate }}</label>
      <div class="input-wrapper">
        <input [type]="showPassword.new ? 'text' : 'password'" formControlName="newPassword"
          placeholder="{{ 'Enter new password' | translate }}" />
        <i class="bi" [ngClass]="showPassword.new ? 'bi-eye-slash' : 'bi-eye'" (click)="togglePassword('new')"></i>
      </div>
    </div>

    <div class="form-row">
      <label>{{ "Confirm Password" | translate }}</label>
      <div class="input-wrapper">
        <input [type]="showPassword.confirm ? 'text' : 'password'" formControlName="confirmPassword"
          placeholder="{{ 'Confirm new password' | translate }}" />
        <i class="bi" [ngClass]="showPassword.confirm ? 'bi-eye-slash' : 'bi-eye'"
          (click)="togglePassword('confirm')"></i>
      </div>
    </div>

    <div class="buttons">
      <button type="button" class="cancel" (click)="onCancel()">
        {{ "Cancel" | translate }}
      </button>
      <button type="button" class="save" (click)="onSave()">
        {{ "Save" | translate }}
      </button>
    </div>
  </form>
</div>